import { Injectable } from '@angular/core';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { environment } from '../../environments/environments';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SupabaseService {
  private supabase: SupabaseClient;

  constructor() {
    this.supabase = createClient(environment.supabaseUrl, environment.supabaseAnonKey);
  }

  // ----------------- AUTH -----------------
  signUp(email: string, password: string) {
    return this.supabase.auth.signUp({ email, password });
  }

  signIn(email: string, password: string) {
    return this.supabase.auth.signInWithPassword({ email, password });
  }

  signOut() {
    return this.supabase.auth.signOut();
  }

  getUser() {
    return this.supabase.auth.getUser();
  }

  getUserData(userId: string) {
    return this.get<any>('datos_usuario', { id_usuario: userId });
  }

  signInWithGoogle() {
    return this.supabase.auth.signInWithOAuth({ provider: 'google' });
  }

  resetPassword(email: string) {
    return this.supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`
    });
    ;
  }

  updatePassword(newPassword: string) {
    return this.supabase.auth.updateUser({ password: newPassword });
  }

  // ----------------- DATABASE (via supabase-js) -----------------
  get<T>(table: string, filters?: Record<string, string | number>, selectFields = '*'): Observable<T[]> {
    let query = this.supabase.from(table).select(selectFields);
    if (filters) {
      for (const key in filters) {
        query = query.eq(key, filters[key]);
      }
    }
    return from(query).pipe(map(response => response.data as T[]));
  }


  insert<T>(table: string, data: Partial<T>): Observable<T> {
    return from(
      this.supabase.from(table).insert(data).select().single()
    ).pipe(map(response => response.data as T));
  }

  update<T>(table: string, match: Partial<T>, data: Partial<T>): Observable<T> {
    return from(
      this.supabase.from(table).update(data).match(match).select().single()
    ).pipe(map(response => response.data as T));
  }

  delete<T>(table: string, match: Partial<T>): Observable<boolean> {
    return from(
      this.supabase.from(table).delete().match(match)
    ).pipe(map(response => !response.error));
  }

  async uploadAvatar(file: File, userId: string): Promise<string> {
    const filePath = `${userId}/${Date.now()}-${file.name}`;

    const { error } = await this.supabase
      .storage
      .from('avatars')
      .upload(filePath, file);

    if (error) throw error;

    const { data } = this.supabase
      .storage
      .from('avatars')
      .getPublicUrl(filePath);

    return data.publicUrl;
  }



}
